module.exports = __webpack_public_path__ + "static/images/cctv_poster.366c047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/cctv_poster.png
// module id = btlQ
// module chunks = 11